import { Filter } from 'model/Filters';
import FilterPopoverTrigger from 'modules/common/Popovers/FilterPopoverTrigger';
import PeoplePopover from 'modules/common/Popovers/PeoplePopover';
import usePopoverTrigger from 'modules/common/SubBars/ExperienceFilterSubNavbar/usePopoverTrigger';
import React from 'react';
import FormatUtils from 'utils/FormatUtils';

interface PeoplePopoverTriggerProps {
  adultsFilter: Filter;
  childrenFilter: Filter;
}

function PeoplePopoverTrigger({
  adultsFilter,
  childrenFilter,
}: PeoplePopoverTriggerProps) {
  const { show, togglePopover, closePopover } = usePopoverTrigger('people');

  return (
    <FilterPopoverTrigger
      destination="/filter/guests/"
      text={FormatUtils.getPeopleText(adultsFilter.value, childrenFilter.value)}
      togglePopover={togglePopover}
      isActive={true}
      show={show}
    >
      <PeoplePopover
        onClose={closePopover}
        nrOfAdults={adultsFilter.value}
        nrOfChildren={childrenFilter.value}
      />
    </FilterPopoverTrigger>
  );
}

export default PeoplePopoverTrigger;
